import InnerHTMLContainer from '../../../../../core/components/molecules/InnerHTMLContainer';
import { Modal } from '../../../../../core/components/templates/Modal';
import {
  Course,
  CourseWeek,
} from '../../../../../modules/Courses/models/Course.model';

interface CourseProgramModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedWeek: CourseWeek | null;
  course: Course | null;
}

function WeekProgramModal({
  isOpen,
  onClose,
  selectedWeek,
  course,
}: CourseProgramModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      position='top-right'
      title={selectedWeek ? selectedWeek.title : ''}
      subtitle={course ? course.title : ''}
      className={`
        m-0 
        mt-[10vh] 
        min-h-[90vh]  
        max-w-full
        
        rounded-b-none 
        md:m-4 
        md:min-h-[calc(100%-2rem)] 
        md:max-w-lg
        md:rounded-b-lg
      `}
    >
      <div className='px-2 pb-3'>
        <InnerHTMLContainer
          data={selectedWeek ? selectedWeek.description : ''}
          align='left'
          type='courseProgram'
          className='text-mono-color-darkest'
        />
      </div>
    </Modal>
  );
}

export { WeekProgramModal };
